import { http } from '@/lib/http';
import type { OperatorProfile } from './types';

export async function getProfile(): Promise<OperatorProfile> {
  return http.get('v1/profile').json<OperatorProfile>();
}

export async function updateProfile(input: Partial<OperatorProfile>): Promise<OperatorProfile> {
  return http.put('v1/profile', { json: input }).json<OperatorProfile>();
}
